import React, { useEffect, useMemo } from "react";
import { getOneService, updateService } from "@payping/redux/actions";
import { DashboardRoutes } from "@/router/constant";
import {
  Button,
  Col,
  Drawer,
  Form,
  Row,
  Skeleton,
  Space,
  Typography,
  useMessagedAsync,
  useMessagedAsyncFn,
} from "@payping/web-components";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "@/assets/scss/profile/Settings.module.scss";
import { Close } from "@payping/icons";
import { SwitchRow } from "@/core/component";

interface MessagingFormType {
  getImportantNotifies: boolean;
  getPayNotify: boolean;
  sendInvoiceReminder: boolean;
}
const MobileProfileMessaging: React.FC = () => {
  const { profile } = DashboardRoutes;
  const { t } = useAppTranslation();
  const dispatch = useAppDispatch();
  const oneService = useAppSelector((state) => state.service.oneService);
  const [form] = Form.useForm<MessagingFormType>();
  const navigate = useNavigate();

  const { loading: loadingGet } = useMessagedAsync(
    async () => {
      await dispatch(getOneService(11));
    },
    [],
    { useProgress: true },
  );

  const [{ loading: loadingEdit }, handleEdit] = useMessagedAsyncFn(
    async (values: MessagingFormType) => {
      await dispatch(updateService({ ...values, serviceType: 11 }));
      navigate(DashboardRoutes.profile.detail.url);
    },
    [],
    undefined,
    { useProgress: true },
  );

  const loading = useMemo(() => loadingGet || loadingEdit, [loadingGet, loadingEdit]);

  useEffect(() => {
    form.setFieldsValue({
      getImportantNotifies: oneService.getImportantNotifies,
      getPayNotify: oneService.getPayNotify,
      sendInvoiceReminder: oneService.sendInvoiceReminder,
    });
  }, [form, oneService]);

  return (
    <Drawer
      open
      title={t("settings.cards.notifications.title")}
      height={"100%"}
      placement={"bottom"}
      closeIcon={false}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            navigate(profile.mRoot.url);
          }}
        />
      }
    >
      <Space direction={"vertical"} size={"middle"} className={"tw-w-full"}>
        <Row className={"tw-w-full"}>
          <Col xs={24} sm={20} md={16} lg={12} xl={10}>
            <Form onFinish={handleEdit} form={form}>
              <Typography.Text className={styles.grey} variant={"body2"}>
                {t("settings.messaging.email.title")}
              </Typography.Text>
              <Form.Item name={"getPayNotify"} valuePropName={"checked"}>
                {loading ? (
                  <Skeleton.Input />
                ) : (
                  <SwitchRow size={"small"} label={t("settings.messaging.email.payMessage")} />
                )}
              </Form.Item>
              <Form.Item name={"getImportantNotifies"} valuePropName={"checked"}>
                {loading ? (
                  <Skeleton.Input />
                ) : (
                  <SwitchRow
                    size={"small"}
                    label={<div className="tw-w-1/2">{t("settings.messaging.email.importantOrAuth")}</div>}
                  />
                )}
              </Form.Item>
              <Typography.Text className={styles.grey} variant={"body2"}>
                {t("settings.messaging.sms.title")}
              </Typography.Text>
              <Form.Item name={"sendInvoiceReminder"} valuePropName={"checked"}>
                {loading ? (
                  <Skeleton.Input />
                ) : (
                  <SwitchRow size={"small"} label={<Col span={19}>{t("settings.messaging.sms.invoiceLink")}</Col>} />
                )}
              </Form.Item>
              <Space>
                <Button type={"primary"} loading={loading} htmlType={"submit"}>
                  {t("enable")}
                </Button>

                <Button variant={"outlined"} color="primary" onClick={() => navigate(-1)}>
                  {t("return")}
                </Button>
              </Space>
            </Form>
          </Col>
        </Row>
      </Space>
    </Drawer>
  );
};

export default MobileProfileMessaging;
